module.exports = "https://r.zoocdn.com/_next/static/images/local-market-stats-e741903ce8b4a621cdd6359b073e0e1b.svg";